import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  welcomeText: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
  },

  name: {
    fontWeight: theme.typography.fontWeightBold,
  },

  inputsContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },

  inputField: {
    margin: '0 5px',
    '& input': {
      textAlign: 'center',
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
      },
      '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
      },
    },
  },

  resendBtn: {
    textTransform: 'initial',
  },
}));

export default useStyles;
